module.exports = __webpack_public_path__ + "static/media/ic_tutorial.34fcd267.svg";